import { IWidgetDataSettings } from '../../_common/interfaces/widget-data-settings.interface';
import { ToroEnums } from '../../../common/enumerations/toro.enums';

import WidgetType = ToroEnums.WidgetType;

export class TaskTrackerConfig implements IWidgetDataSettings {

    constructor(dataSettings: IWidgetDataSettings) {
        if (dataSettings) {
            this.widgetType = dataSettings.widgetType;
            this.showStaleDataAlert = dataSettings.showStaleDataAlert;
            this.dataRefreshIntervalMinutes = dataSettings.dataRefreshIntervalMinutes;
            this.staleDataThresholdMinutes = dataSettings.staleDataThresholdMinutes;
        }
    }

    isTaskTrackerConfig = true;

    widgetType: WidgetType;
    showStaleDataAlert: boolean;
    dataRefreshIntervalMinutes = 60;
    staleDataThresholdMinutes = 75;
}
